// @ts-ignore
/* eslint-disable */
import request from '../../../requestInstance';
import { CommonResult } from '../../CommonType';
import type { API } from './typings.d';

/** 受講者進捗一覧－初期化（全件検索） GET /development/progress/init */
export async function initProgressList(
  params: { pageNum?: number; pageSize?: number },
  options?: { [key: string]: any },
): Promise<CommonResult<API.ProgressesListResponse>> {
  return request<CommonResult<API.ProgressesListResponse>>('/api/development/progress/init', {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
    },
    params,
    ...(options || {}),
  });
}

/** 受講者進捗一覧－進捗検索（条件検索） GET /development/progress/courses */
export async function searchProgressList(
  params: {
    accountName?: string;
    learningLevel?: number;
    pageNum?: number;
    pageSize?: number;
  },
  options?: { [key: string]: any },
): Promise<CommonResult<API.ProgressesListResponse>> {
  return request<CommonResult<API.ProgressesListResponse>>('/api/development/progress/courses', {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
    },
    params,
    ...(options || {}),
  });
}

/** 受講者進捗一覧－中コース回答一覧検索 GET /development/progress/medium-qa-answers */
export async function getMediumQaAnswers(
  params: {
    accountId?: number;
    accountName?: string;
    mediumCourseName?: string;
    pageNum?: number;
    pageSize?: number;
  },
  options?: { [key: string]: any },
): Promise<CommonResult<API.MediumQaAnswerSearchResponse>> {
  return request<CommonResult<API.MediumQaAnswerSearchResponse>>(
    '/api/development/progress/medium-qa-answers',
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
      },
      params,
      ...(options || {}),
    },
  );
}

export async function getSelfProgressReminderUnreadCount(options?: {
  [key: string]: any;
}): Promise<CommonResult<number>> {
  return request<CommonResult<number>>('/api/development/progress/reminders/self/unread-count', {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
    },
    ...(options || {}),
  });
}

export async function listSelfProgressReminders(options?: {
  [key: string]: any;
}): Promise<CommonResult<API.ProgressReminderResponse>> {
  return request<CommonResult<API.ProgressReminderResponse>>(
    '/api/development/progress/reminders/self/list',
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
      },
      ...(options || {}),
    },
  );
}

export async function getProgressCalendar(
  params: { accountId?: number; year?: number; month?: number },
  options?: { [key: string]: any },
): Promise<CommonResult<API.ProgressCalendarResponse>> {
  return request<CommonResult<API.ProgressCalendarResponse>>('/api/development/progress/calendar', {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
    },
    params,
    ...(options || {}),
  });
}

export async function saveProgressCalendar(
  body: API.ProgressCalendarSaveRequest,
  options?: { [key: string]: any },
): Promise<CommonResult<API.ProgressCalendarOperationResponse>> {
  return request<CommonResult<API.ProgressCalendarOperationResponse>>(
    '/api/development/progress/calendar/save',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
      },
      data: body,
      ...(options || {}),
    },
  );
}

export async function deleteProgressCalendar(
  body: { calendarId: number },
  options?: { [key: string]: any },
): Promise<CommonResult<API.ProgressCalendarOperationResponse>> {
  return request<CommonResult<API.ProgressCalendarOperationResponse>>(
    '/api/development/progress/calendar/delete',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
      },
      data: body,
      ...(options || {}),
    },
  );
}

export async function updateLearningTask(
  body: { learningId: number; learningTask: string },
  options?: { [key: string]: any },
): Promise<CommonResult<{ learningId: number; message: string }>> {
  return request<CommonResult<{ learningId: number; message: string }>>(
    '/api/development/progress/task/update',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
      },
      data: body,
      ...(options || {}),
    },
  );
}

export async function updateLearningRemark(
  body: { learningId: number; learningRemark: string },
  options?: { [key: string]: any },
): Promise<CommonResult<{ learningId: number; message: string }>> {
  return request<CommonResult<{ learningId: number; message: string }>>(
    '/api/development/progress/remark/update',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
      },
      data: body,
      ...(options || {}),
    },
  );
}

export async function calculateProgress(options?: {
  [key: string]: any;
}): Promise<
  CommonResult<{ processedAccounts: number; insertedCount: number; updatedCount: number }>
> {
  return request<
    CommonResult<{ processedAccounts: number; insertedCount: number; updatedCount: number }>
  >('/api/development/progress/calculate', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
    },
    data: {},
    ...(options || {}),
  });
}
